module.exports = __webpack_public_path__ + "img/icn_email.7db0fb7d.svg";